module.exports = __webpack_public_path__ + "img/memberinfo.43a93b52.svg";